/** @jsxImportSource @emotion/react */
import { Controls } from 'components/landing/ui';

import { modList } from '../../../settings';

const ModuleSelect = ({ currentModuleId, selectModule }) => {
  const { num } = modList[currentModuleId];
  const total = Object.keys(modList).length;

  const handlePrev = () => {
    selectModule(Object.keys(modList)[num - 2]);
  };

  const handleNext = () => {
    selectModule(Object.keys(modList)[num]);
  };

  return (
    <Controls
      title="Видео обзоры"
      current={num}
      total={total}
      onNext={handleNext}
      onPrev={handlePrev}
    />
  );
};

export default ModuleSelect;
